<app-navbar></app-navbar>

<div class="min-h-screen bg-gray-50 py-8">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    <!-- Header compacto con título y botón en la misma línea -->
    <div class="flex items-center justify-between mb-6">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Landing Pages</h1>
        <div class="flex items-center gap-2 mt-2">
          <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-50 text-blue-700 border border-blue-200">
            <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            Alojamiento: {{ currentOrgId() }}
          </span>
          <span class="text-sm text-gray-500">
            {{ pages().length }} página(s)
          </span>
        </div>
      </div>

      <button
        (click)="crearNueva()"
        class="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow-md font-medium">
        <fa-icon [icon]="faPlus" class="text-sm"></fa-icon>
        <span>Nueva Landing Page</span>
      </button>
    </div>

    <!-- Mensaje de error -->
    @if (errorMsg()) {
      <div class="mb-6 bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3">
        <svg class="w-5 h-5 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p class="text-sm text-red-800">{{ errorMsg() }}</p>
      </div>
    }

    <!-- Loading state -->
    @if (isLoading()) {
      <div class="flex flex-col items-center justify-center py-20">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p class="text-gray-600 font-medium">Cargando páginas...</p>
      </div>
    }

    <!-- Estado vacío -->
    @else if (pages().length === 0 && !errorMsg()) {
      <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-12 text-center">
        <div class="max-w-md mx-auto">
          <div class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-2">No hay landing pages aún</h3>
          <p class="text-gray-600 mb-6">
            Comienza creando tu primera página de aterrizaje para este alojamiento.
            Podrás promocionar paquetes especiales, habitaciones o temporadas.
          </p>
          <button
            (click)="crearNueva()"
            class="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium">
            <fa-icon [icon]="faPlus"></fa-icon>
            <span>Crear Primera Página</span>
          </button>
        </div>
      </div>
    }

    <!-- Lista de páginas con diseño moderno -->
    @else {
      <div class="space-y-4">
        @for (page of pages(); track page.page_id) {
          <div class="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-200 p-6 border border-gray-200">
            <div class="flex gap-6">

             <!-- Thumbnail con la primera imagen de la página -->
<div class="flex-shrink-0">
  @if (page.images && page.images.length > 0) {
    <img
      [src]="page.images[0].url"
      [alt]="page.images[0].alt_text || page.title"
      class="w-56 h-32 object-cover rounded-lg border border-gray-200 shadow-sm"
    />
  } @else {
    <div class="w-56 h-32 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg flex items-center justify-center border border-blue-200">
      <svg class="w-12 h-12 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    </div>
  }
</div>


              <!-- Contenido principal -->
              <div class="flex-1 flex flex-col justify-between min-w-0">
                <div>
                  <!-- Título con badge de estado -->
                  <div class="flex items-center gap-3 mb-2">
                    <h3 class="text-lg font-semibold text-gray-900 truncate">
                      {{ page.title || 'Sin título' }}
                    </h3>
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                      <span class="mr-1">●</span> Publicado
                    </span>
                  </div>

                  <!-- Slug como enlace -->
                  <div class="flex items-center gap-2 mb-3">
                    <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                    <a
                      [href]="getPageUrl(page.slug)"
                      target="_blank"
                      class="text-sm text-gray-600 hover:text-blue-600 transition-colors truncate font-mono">
                      {{ page.slug }}
                    </a>
                  </div>

                  <!-- Metadata con iconos -->
                  <div class="flex items-center gap-4 text-sm text-gray-500">
                    <div class="flex items-center gap-1.5">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <span>{{ page.created_at | date:'medium' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botones de acción modernizados -->
              <div class="flex items-start gap-2">
                <!-- Ver -->
                <button
                  (click)="verLanding(page.slug)"
                  class="p-2.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 group"
                  title="Ver página">
                  <fa-icon [icon]="faEye" class="text-base group-hover:scale-110 transition-transform"></fa-icon>
                </button>

                <!-- Editar -->
                <button
                  (click)="editarLanding(page.page_id, page.slug)"
                  class="p-2.5 rounded-lg border border-blue-200 text-blue-600 hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 group"
                  title="Editar página">
                  <fa-icon [icon]="faEdit" class="text-base group-hover:scale-110 transition-transform"></fa-icon>
                </button>

                <!-- Eliminar -->
                <button
                  (click)="deletePage(page.page_id, page.slug)"
                  class="p-2.5 rounded-lg border border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300 transition-all duration-200 group"
                  title="Eliminar página">
                  <fa-icon [icon]="faTrash" class="text-base group-hover:scale-110 transition-transform"></fa-icon>
                </button>
              </div>

            </div>
          </div>
        }
      </div>
    }

  </div>
</div>

<app-footer></app-footer>
